import { render, staticRenderFns } from "./Caf.vue?vue&type=template&id=495fce63"
import script from "./Caf.vue?vue&type=script&lang=js"
export * from "./Caf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports